import { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination } from 'antd'
import ChatBotRecordDetail from './detail'
import ChatbotRecordRibbon from './ribbon'
import ExportChatbotRecord from './export'

export default function ChatbotRecord() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [recordData, setRecordData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [propsData, setPropsData] = useState({})
  const [isDetailVisible, setIsDetailVisible] = useState(false)
  const [isExportVisible, setIsExportVisible] = useState(false)

  const initialConditions = {
    start_time: null,
    end_time: null
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  useEffect(() => {
    axios.post('/p/chatbot/record/list/get', { 
      merchant_oid: merchantOid,
      start_time: filterValue.start_time,
      end_time: filterValue.end_time,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setRecordData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'records': response.data.records
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, currentPage, filterValue])

  const previewDetail = (oid) => {
    setIsDetailVisible(true)
    setPropsData({ oid: oid})
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">会话记录</div>
          <ChatbotRecordRibbon 
            filterValue={filterValue} 
            setFilterValue={setFilterValue}
            isExportVisible={() => { setIsExportVisible(true) }} 
          />
        </div>

        <div className='public-main-style'>
          <div className='public-main-style2'>
            <table className='public-main-style2-item'>
              <thead>
                <tr className='public-main-style2-thead'>
                  <th>
                    <div className='public-main-style2-title'>最后咨询问题</div>
                  </th>
                  <th>对话次数</th>
                  <th>最后对话时间</th>
                </tr>
              </thead>

              <tbody>
                {recordData.records && (recordData.records.length > 0 ? (recordData.records.map((item) => (
                  <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { previewDetail(item.conversation_id) }}>
                    <td>
                      <div className='public-main-style2-title2'>
                        <p>Q：{item.user_question}</p>
                        <p>A：{item.assistant_answer}</p>
                      </div>
                    </td>
                    <td>{item.record_count}</td>
                    <td>{item.create_time}</td>
                  </tr>
                ))) : (
                  <tr className='public-main-style2-tbodyEmpty'>
                    <td colSpan='3'><span>暂无数据</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className='pagination'>
            <Pagination 
              current={currentPage}
              total={recordData.total}
              pageSize={20}
              onChange={(page) => setCurrentPage(page)}
              showTotal={(total) => `共${total}条`}
              showSizeChanger={false}
              hideOnSinglePage={true}
              showQuickJumper={true}
            />
          </div>
        </div>
      </div>

      {isDetailVisible && <ChatBotRecordDetail
        data={propsData}
        isOpen={isDetailVisible}
        isCancel={() => { setIsDetailVisible(false) }}
      />}

      {isExportVisible && <ExportChatbotRecord
        filterValue={filterValue}
        isOpen={isExportVisible}
        isCancel={() => { setIsExportVisible(false) }}
      />}
    </div>
  )
}
